import type { FC } from "react";

import type { BuyPrizeElementResponseType, RewardType } from "@jti/rest-api-types";

import { DelayedLotteryConfirmation } from "./DelayedLotteryConfirmation";
import { InstantLotteryConfirmation } from "./InstantLotteryConfirmation";
import { PhysicalPrizeConfirmation } from "./PhysicalPrizeConfirmation";
import { VirtualPrizeConfirmation } from "./VirtualPrizeConfirmation";

export type PrizeConfirmationProps = {
  rewardTitle: string;
  rewardType: RewardType;
  onTryAgain?: () => void;
  onComplete?: () => void;
  onExploreMoreRewards?: () => void;
  prizesData?: BuyPrizeElementResponseType;
  isUserEligibleForReward?: boolean;
  isInstantLotteryWon?: boolean;
};

export const PrizeConfirmation: FC<PrizeConfirmationProps> = ({
  rewardType,
  prizesData,
  rewardTitle,
  onExploreMoreRewards,
  onComplete,
  isUserEligibleForReward,
  isInstantLotteryWon,
}) => {
  const isDelayedLottery = rewardType.includes("delayed_lottery");
  const isInstantLottery = rewardType.includes("instant_lottery");

  if (rewardType === "simplified") {
    return (
      <VirtualPrizeConfirmation
        prizesData={prizesData}
        rewardTitle={rewardTitle}
        onComplete={onComplete}
        onExploreMoreRewards={onExploreMoreRewards}
      />
    );
  }
  if (rewardType === "physical") {
    return (
      <PhysicalPrizeConfirmation
        rewardTitle={rewardTitle}
        onComplete={onComplete}
        onExploreMoreRewards={onExploreMoreRewards}
      />
    );
  }

  if (isDelayedLottery) {
    return <DelayedLotteryConfirmation rewardTitle={rewardTitle} onExploreMoreRewards={onExploreMoreRewards} />;
  }

  if (isInstantLottery) {
    return (
      <InstantLotteryConfirmation
        isInstantLotteryWon={isInstantLotteryWon}
        rewardName={rewardTitle}
        onTryAgain={onComplete}
        onExploreMoreRewards={onExploreMoreRewards}
        isUserEligibleForReward={isUserEligibleForReward}
      />
    );
  }
};
